import { render, staticRenderFns } from "./ExpressPoshtaReportTable.vue?vue&type=template&id=4d068430&scoped=true"
import script from "./ExpressPoshtaReportTable.vue?vue&type=script&lang=js"
export * from "./ExpressPoshtaReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d068430",
  null
  
)

export default component.exports